import React from "react"
import PropTypes from "prop-types"
import { semantic } from '@lexody/design-tokens'

import WritingResponseClap from './WritingResponseClap'
import WeeklyWritingTextArea from './WeeklyWritingTextArea'

class WritingResponse
 extends React.Component {
   constructor(props) {
     super(props)

     this.state = {
       isEditing: false,
       text: ''
     }

     this.renderButtons = this.renderButtons.bind(this)
     this.editTopic = this.editTopic.bind(this)
     this.updateText = this.updateText.bind(this)
     this.updateWritingText = this.updateWritingText.bind(this)
   }

   editTopic() {
     this.setState({
       isEditing: true
     })
   }

   componentDidMount() {
     this.setState({
       text: this.props.response.body
     })
   }

   updateWritingText(text) {
    this.setState({
      text: text
    })
   }

   updateText() {
     $.ajax({
       url: `../update_writing_response`,
       dataType: 'JSON',
       type: 'POST',
       header: {
         'Content-Type': 'application/json'
       },
       data: {
         body: this.state.text,
         id: this.props.response.id,
       },
       success: (data) => {
         this.setState({
           isEditing: false,
         })
         return
       },
       error: function(xhr, status, err) {
         console.log(err)
       }.bind(this)
     });
   }

   renderButtons() {
     if(this.props.currentUser.id === this.props.response.user.id) {
       return(
         <div onClick={() => this.editTopic()} style={{justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row', cursor: 'pointer'}}>
           <h4 style={{color: semantic.primary.surface.default}}>Edit</h4>
         </div>
       )
     }
     return (<img src={this.props.response.user_avatar} style={{height: 40, width: 40, borderRadius: 30}} onClick={() => window.location.assign(`/profile/${this.props.response.user.slug}`)}/>)
   }

  render() {
    if(this.state.isEditing === true) {
      return(
        <div style={{width: 350, maxWidth: '95%', margin: 'auto'}}>
          <WeeklyWritingTextArea text={this.state.text} updateWritingText={this.updateWritingText}/>
          <button className="btn_primary_full"  style={{textAlign: 'center', marginTop: 12, marginBottom: 12, cursor: 'pointer'}} onClick={this.updateText}>Save</button>
        </div>
      )
    }
    return(
      <div  style={{border: `2px solid ${semantic.greyscale.surface.default}`, padding:12, maxWidth: 350, margin: 12, display: 'inline-block', borderRadius: 10, height: '100%'}}>
          <h5 style={{textAlign: 'left'}}>{this.state.text}</h5>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: 15}}>
            {this.renderButtons()}
          </div>
      </div>
    )
  }

}
//          <WritingResponseClap clapIcon={this.props.clapIcon} clapLottie={this.props.clapLottie} response={this.props.response} currentUser={this.props.currentUser}/>


export default WritingResponse;
